class MFooter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const mobileAccordion = this.querySelector(".m-footer--accordion");
    const mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");

    if (mobileAccordion) {
      if (MinimogTheme.config.mqlMobile) {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      }
      document.addEventListener("matchMobile", () => {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      });
    }

    // Set mobile stickybar height
    if (mobileStickyBar) {
      document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      document.addEventListener("matchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
      document.addEventListener("unmatchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
    }
  }
}
customElements.define("m-footer", MFooter);


document.addEventListener('DOMContentLoaded', function() {
    // Select the dropdown element
    const selectElement = document.querySelector('select.gt_selector');

    // Check if the select element exists
    if (selectElement) {
        // Remove the first option (index 0)
        selectElement.remove(0);

        // Find the third option (value="da|de") and set it as selected
        const options = selectElement.querySelectorAll('option');
        options.forEach(option => {
            if (option.value === 'da|de') {
                selectElement.value = option.value;  // Set the value directly
                option.selected = true;  // Ensure the option is selected
            }
        });

        // Trigger the change event to simulate a user action
        const event = new Event('change', {
            'bubbles': true,
            'cancelable': true
        });
        selectElement.dispatchEvent(event);  // Dispatch the event to trigger any listeners
    }
});